import React from "react";
import { Link } from "react-router-dom";
import logoutSVG from "../../../asset/img/logout.svg";
import InfoTooltip from "../../common/tooltip/info";
import { withNamespaces } from 'react-i18next';

function Logout({ removeSession, t }) {
  return (
   
      <Link to="/logout">
         <InfoTooltip info={t("logout")} placement="bottom">
        <button type="button" className="logout-button">
          <img src={logoutSVG} className="logout-icon" />
        </button>
        </InfoTooltip>
      </Link>
   
  );
}

export default withNamespaces()(Logout);



// WEBPACK FOOTER //
// ./src/components/header/logout/index.js